import { render, staticRenderFns } from "./piyasaarastirmatutanagi.vue?vue&type=template&id=13b4e264&"
import script from "./piyasaarastirmatutanagi.vue?vue&type=script&lang=js&"
export * from "./piyasaarastirmatutanagi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports